import {
    Table,
    TextFilter,
    Pagination,
    CollectionPreferences,
    Toggle, Header, Button
} from '@amzn/awsui-components-react-v3';

import { TEXT, PAGINATION, TOGGLE_PLACEMENT } from '../common/constants';
import React, {useState, useEffect} from "react";
import {useCollection} from "@amzn/awsui-collection-hooks";
import {EmptyState} from "./common/EmptyState";

/**
 * Displays the main body (table) of the report.
 */
export function getMatchesCountText(count: number) {
    return count === 1 ? `1 match` : `${count} matches`;
}

export const ReportTable = (props) => {
  const {
    loading,
    displayInMillions,
    reportRows,
    columnDefinitions,
    contentSelectorOptions,
    onContentSelectionChange,
    onToggleMillions,
    togglePlacement,
    showTableFilter,
    wrapLines,
    visibleColumns
  } = props;

  useEffect(() => {
    if(props.visibleColumns !== preferences.visibleContent){
      setPreferences({...preferences, visibleContent: props.visibleColumns});
    }
  });

  const toggleInHeader = togglePlacement === TOGGLE_PLACEMENT.IN_HEADER;
  const [preferences, setPreferences] = useState({
      pageSize: PAGINATION.SIZE,
      visibleContent: visibleColumns,
      wrapLines: wrapLines || false,
  });

  const { items, actions, filteredItemsCount, collectionProps, filterProps, paginationProps } = useCollection(reportRows || [], {
      filtering: {
          empty: (
              <EmptyState
                  title="No result"
                  subtitle="No result to display."
              />
          ),
          noMatch: (
              <EmptyState
                  title="No matches"
                  subtitle="We can’t find a match."
                  action={<Button onClick={() => actions.setFiltering('')}>Clear filter</Button>}
              />
          )
      },
        pagination: { pageSize: preferences.pageSize },
        sorting: {}, // use default so pass empty object
        selection: {}
  });

    return (
      <div data-cy="accuracy-table">
        <Table
          {...collectionProps}
          className="ZebraStripesTable accuracy-table-container"
          columnDefinitions={columnDefinitions}
          loading={loading}
          loadingText={TEXT.LOADING}
          visibleColumns={preferences.visibleContent}
          items={items}
          stickyHeader={true}
          onBeforeUnstick={(event) => event.preventDefault()}
          wrapLines={preferences.wrapLines}
          header={
              <Header
                  variant="h2"
                  actions={
                      <div className="awsui-util-action-stripe">
                          <div className="awsui-util-action-stripe-title"/>
                          <div className="awsui-util-action-stripe-group">
                              {toggleInHeader && (
                                  <Toggle
                                      checked={displayInMillions}
                                      disabled={loading}
                                      onChange={onToggleMillions}
                                  >
                                      {TEXT.DISPLAY_IN_MILLIONS}
                                  </Toggle>
                              )}
                          </div>
                      </div>
                  }
              />
          }
          empty={
            <div className="awsui-util-t-c">
              <div className="awsui-util-pt-xs awsui-util-mb-xs">
                <b>{TEXT.EMPTY}</b>
              </div>
            </div>
          }
          filter={showTableFilter &&
              <TextFilter
                  {...filterProps}
                  countText={getMatchesCountText(filteredItemsCount)}
                  filteringPlaceholder="Filter"
                  filteringAriaLabel="Filter"
              />
          }
          pagination={
              <Pagination
                  ariaLabels={{
                      nextPageLabel: "Next page",
                      previousPageLabel: "Previous page",
                      pageLabel: pageNumber =>
                          `Page ${pageNumber} of all pages`
                  }}
                  {...paginationProps}
              />
          }
            preferences={
              <CollectionPreferences
                  onConfirm={({detail}) => {
                      setPreferences(detail);
                      onContentSelectionChange(detail);
                  }}
                  preferences={preferences}
                  pageSizePreference={{
                      title: "Select page size",
                      options: PAGINATION.SELECTOR
                  }}
                  visibleContentPreference={{
                      title: "Select visible columns",
                      options: contentSelectorOptions
                  }}
                  wrapLinesPreference={{
                      label: 'Wrap lines',
                      description: 'Check to see all the text and wrap the lines',
                  }}
                  cancelLabel={TEXT.CANCEL}
                  confirmLabel={TEXT.CONFIRM}
                  title={TEXT.PREFERENCES}
                  id="table-preferences"
              />

            }
          />
        {
          <div align="right">
            <small>v3</small>
          </div>
        }
      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/reports/components/report_table.js